//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbPanel from '@/elements/panel/rb-panel.vue'
import RbFacetValues from './rb-facet-values.vue'
import { FACET_KEYS } from '@/scripts/constants/plp'
const RbSelectedFacets = () => import('./rb-selected-facets.vue')
import RbToggleBlock from './rb-toggle-block/rb-toggle-block.vue'
import PromoToggles from '@/scripts/libs/promo-toggles'
export default {
  name: 'RbFacetsPanel',
  components: {
    RbToggleBlock,
    RbPanel,
    RbFacetValues,
    RbSelectedFacets,
  },

  props: {
    facets: {
      type: Array,
      required: true,
    },
    panelIsOpen: {
      type: Boolean,
      default: false,
    },
    totalProducts: {
      type: Number,
      default: 0,
    },
    appliedFacets: {
      type: Array,
      required: true,
    },
    minPriceRange: {
      type: Number,
      required: true,
    },
    maxPriceRange: {
      type: Number,
      required: true,
    },
    resetFacetPrice: {
      type: Boolean,
      default: false,
    },
    disabledCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    facetsElements() {
      return this.facets.map((fv) => {
        if (fv.key === FACET_KEYS.PROMO_FILTER) {
          const allPromoElement = fv.values.shift()
          const allPromotionsAreActive = fv.values.every((v) => v?.active)
          if (allPromotionsAreActive && allPromoElement) {
            fv.values = fv.values.map((value) =>
              Object.assign({}, value, {
                active: !value?.active,
              })
            )
            allPromoElement.active = true
          }
          fv.values.unshift(allPromoElement)

          const normalizedToMergeSimilarPromotions = this.normalizeToMergeSimilarPromotions(
            fv.values
          )
          const toggles = PromoToggles.mergePromoToggles(normalizedToMergeSimilarPromotions)
          const normalizedToggles = this.normalizeToFacet(toggles)

          fv.values = normalizedToggles
        }
        return fv
      })
    },
  },
  methods: {
    normalizeToMergeSimilarPromotions(facets) {
      const values = facets?.map((facet) => {
        const toggles = facet.value
        const entryValue = typeof toggles === 'string' ? [toggles] : toggles
        return {
          ...facet,
          entryValue: entryValue,
          badge: facet.label,
        }
      })

      return values
    },
    normalizeToFacet(toggles) {
      const facets = toggles.map((toggle) => {
        return {
          ...toggle,
          value: toggle.entryValue,
        }
      })
      facets.forEach((facet) => {
        delete facet.entryValue
        delete facet.badge
      })

      return facets
    },
    labelToShow(label) {
      const rg = new RegExp(/([a-zA-Z])\.([a-zA-Z])/)
      return rg.test(label) ? this.$t(label) : label
    },
    isToggleBlock(key) {
      return [FACET_KEYS.HIGH_PRESCRIPTION].includes(key)
    },
  },
}
